import * as React from 'react';
import { TableCellProps } from './TableProps';

type Props = TableCellProps<any, string>;

export const DateCell: React.FC<Props> = ({ formattedValue }) => {
  return <span>{formattedValue}</span>;
};
